import { employeeSchema } from "@/components/Forms/schema/employeeSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createDataSelector, createResourceCollectionSelector } from "jsonapi-zod-query";

const resourceSelector = createResourceCollectionSelector({
    type: "employee",
    attributesSchema: employeeSchema,
});

export const employeesSelector = createDataSelector(resourceSelector);
export type EmployeesType = ReturnType<typeof employeesSelector>;

type Props = {
    type: string;
    includeInactive: boolean;
};

export const useFetchEmployeeByType = ({
    type,
    includeInactive = false,
}: Props): UseQueryResult<EmployeesType> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: [`employee-${type}-${includeInactive}`],
        queryFn: async () => {
            const fetchURL = apiUrl(`/employee/by-type/${type}/${includeInactive}`);
            const response = await fetch(fetchURL.href);
            return await response.json();
        },
        select: employeesSelector,
    });
};
